/**
 * Single-open accordion with image crossfade.
 * Clicking a closed step opens it, closes the current one, and swaps the linked image.
 *
 * @param {object} [opts]
 * @param {string} [opts.root=".no-main--process"]   container holding [data-step] + [data-step-img]
 * @param {string} [opts.panelSel=".no-main--process__panel"]
 * @param {string} [opts.triggerSel=".no-main--process__trigger"]
 */
export function initProcessAccordion(opts = {}) {
  const {
    root = ".no-main--process",
    panelSel = ".no-main--process__panel",
    triggerSel = ".no-main--process__trigger",
  } = opts;

  const section = document.querySelector(root);
  if (!section) return;

  const steps = Array.from(section.querySelectorAll("[data-step]"));
  const imgs = section.querySelectorAll("[data-step-img]");
  if (!steps.length) return;

  const animatePanel = (panel, open) => {
    panel.style.overflow = "hidden";
    panel.style.transition = "height 0.34s ease";

    if (open) {
      panel.hidden = false;
      panel.style.height = "0px";
      requestAnimationFrame(() => {
        panel.style.height = `${panel.scrollHeight}px`;
      });
      const onEnd = (e) => {
        if (e.target !== panel || e.propertyName !== "height") return;
        panel.style.height = "auto";
        panel.removeEventListener("transitionend", onEnd);
      };
      panel.addEventListener("transitionend", onEnd);
    } else {
      if (panel.hidden) return;
      panel.style.height = `${panel.scrollHeight}px`;
      requestAnimationFrame(() => {
        panel.style.height = "0px";
      });
      const onEnd = (e) => {
        if (e.target !== panel || e.propertyName !== "height") return;
        panel.hidden = true;
        panel.removeEventListener("transitionend", onEnd);
      };
      panel.addEventListener("transitionend", onEnd);
    }
  };

  const activate = (stepEl) => {
    if (stepEl.classList.contains("is-open")) return;

    const stepId = stepEl.dataset.step;

    steps.forEach((s) => {
      const p = s.querySelector(panelSel);
      const t = s.querySelector(triggerSel);
      if (s === stepEl) {
        s.classList.add("is-open");
        t?.setAttribute("aria-expanded", "true");
        if (p) animatePanel(p, true);
      } else {
        s.classList.remove("is-open");
        t?.setAttribute("aria-expanded", "false");
        if (p) animatePanel(p, false);
      }
    });

    imgs.forEach((img) => {
      img.classList.toggle("is-active", img.dataset.stepImg === stepId);
    });
  };

  steps.forEach((step, i) => {
    const panel = step.querySelector(panelSel);
    const trigger = step.querySelector(triggerSel);

    if (i === 0) {
      step.classList.add("is-open");
      trigger?.setAttribute("aria-expanded", "true");
      if (panel) { panel.hidden = false; panel.style.height = "auto"; }
    } else {
      step.classList.remove("is-open");
      trigger?.setAttribute("aria-expanded", "false");
      if (panel) panel.hidden = true;
    }

    trigger?.addEventListener("click", () => activate(step));
  });

  section.querySelector("[data-step-img='1']")?.classList.add("is-active");
}
